import { Box, Paper, Divider } from '@mui/material';
import DateRangePreset from './DateRangePreset';
import MultiSelectChips from './MultiSelectChips';
import type { DateRange } from '@/types';

interface ChannelFilterBarProps {
  dateRange: DateRange;
  tickers: string[];
  availableTickers: string[];
  onDateRangeChange: (range: DateRange) => void;
  onTickersChange: (tickers: string[]) => void;
}

export default function ChannelFilterBar({
  dateRange,
  tickers,
  availableTickers,
  onDateRangeChange,
  onTickersChange,
}: ChannelFilterBarProps) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        mb: 3,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 3,
          flexWrap: 'wrap',
        }}
      >
        {/* Date Range Preset */}
        <DateRangePreset value={dateRange.preset} onChange={onDateRangeChange} />

        <Divider orientation="vertical" flexItem />

        {/* Ticker Filter */}
        <Box sx={{ flex: 1, minWidth: 200 }}>
          <MultiSelectChips
            label="标的"
            options={availableTickers}
            value={tickers}
            onChange={onTickersChange}
          />
        </Box>
      </Box>
    </Paper>
  );
}
